import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import './App.css';

// Components
import Navbar from './components/Navbar';
import Calendar from './components/Calendar';
import Login from './components/Login';
import Register from './components/Register';
import AddPerson from './components/AddPerson';
import ManageFriends from './components/ManageFriends';
import AdminPanel from './components/AdminPanel'; // Import the new AdminPanel component
import HolidayPlanner from './components/HolidayPlanner'; // Import the new HolidayPlanner component
import Profile from './components/Profile'; // Import the Profile component
import Footer from './components/Footer'; // Import the Footer component
import LoadingSplash from './components/LoadingSplash'; // Import the LoadingSplash component

function App() {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Authentication state observer
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
    });

    // Cleanup subscription
    return () => unsubscribe();
  }, []);

  // Protected route component
  const ProtectedRoute = ({ children }) => {
    if (loading) return <LoadingSplash />;
    if (!currentUser) return <Navigate to="/login" />;
    return children;
  };

  if (loading) {
    return <LoadingSplash />;
  }

  return (
    <Router>
      <div className="App">
        <Navbar currentUser={currentUser} />
        <div className="container mt-2 flex-grow-1">
          <Routes>
            <Route path="/" element={<Calendar currentUser={currentUser} />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route 
              path="/add-person" 
              element={
                <ProtectedRoute>
                  <AddPerson />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/manage-friends" 
              element={
                <ProtectedRoute>
                  <ManageFriends />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute>
                  <AdminPanel currentUser={currentUser} />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/holiday-planner" 
              element={
                <ProtectedRoute>
                  <HolidayPlanner currentUser={currentUser} />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <Profile currentUser={currentUser} />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
